module.exports = __webpack_public_path__ + "img/imgBox_img.91d99cb3.png";